import api from "./api";

// Subscription endpoints (ICS / webcal / CalDAV) for the current user's feed.
// The returned URLs embed a capability token — treat them like a password.
async function getCalendarFeed() {
  const response = await api.get("api/calendar/feed");
  return response.data;
}

// Full item detail, including the real description that the CalDAV feed redacts.
async function getCalendarItemDetail(id, { signal } = {}) {
  const response = await api.get(`api/calendar/items/${id}`, { signal });
  return response.data;
}

// Task-like calendar items for the signed-in user — the Today's-tasks page. Tasks are excluded
// from the calendar feeds, so this REST list is their only source.
async function fetchTodaysTasks({ signal } = {}) {
  const { data } = await api.get("api/calendar/tasks", { signal });
  // [{ id, title, description, priority, due, customerId, paymentRequestId, taskType,
  //    instalmentNumber, instalmentCount, promisedDate, promisedAmount }]
  return data;
}

// Created over REST rather than CalDAV so the task can be owned by a colleague and linked to a customer.
async function createCalendarTask({ title, description, dueAt, assigneeUserId, customerId }) {
  const { data } = await api.post("api/calendar/tasks", {
    title,
    description,
    dueAt,
    assigneeUserId,
    customerId,
  });
  return data;
}

// Complete a task (e.g. after a reminder is sent). Throws on error so the caller can surface it.
async function completeTask(id) {
  await api.post(`api/calendar/tasks/${id}/complete`);
}

// Dismiss a task (cancels the calendar item). Throws on error.
async function dismissTask(id) {
  await api.post(`api/calendar/tasks/${id}/dismiss`);
}

// Sends the exact payment request the pipeline was about to auto-send, for an
// IncomingPaymentReview task. Throws on error (e.g. 400 when there's no contact detail on file).
async function sendScheduledRequest(id) {
  await api.post(`api/calendar/tasks/${id}/send-request`);
}

// Resolves a decision-graph IncomingPaymentReview (a parked human_approval step): "send_anyway"
// resumes the send chain, "dismiss" continues the plan. The action-service routes the branch.
async function submitReviewDecision(actionId, stepId, decision) {
  await api.post(`api/calendar/actions/${actionId}/steps/${stepId}/decision`, { decision });
}

export {
  getCalendarFeed,
  getCalendarItemDetail,
  fetchTodaysTasks,
  createCalendarTask,
  completeTask,
  dismissTask,
  sendScheduledRequest,
  submitReviewDecision,
};
